import React, { useState } from "react";
import data from "../../data/HeaderDropDown/headerdropdown.json";
import "../../assets/css/style.css";
import { IoIosArrowDown } from "react-icons/io";

export default function HeaderDropDown({ navItem }) {
  const [activeLink, setActiveLink] = useState(null);
  return (
    // <li>
    //   <a href={navItem.link}>{navItem.title}</a>
    //   <ul className="dropdown-menu">
    //     {navItem.subMenu.map((item) => (
    //       <li key={item.id}>
    //         <a href={item.link}>{item.title}</a>
    //       </li>
    //     ))}
    //   </ul>
    // </li>
    <ul className="dropdown">
      {data.map((item) => (
        <li key={item.id}>
          {item.title}
          <IoIosArrowDown />
          {item.subMenu && (
            <ul className="dropdownMenu">
              {item.subMenu.map((navItem) => (
                <li
                  key={navItem.id}
                  onClick={() => setActiveLink(navItem.id)}
                  className={activeLink === navItem.id ? "active" : ""}
                >
                  <a href={navItem.link} target="_blank">
                    {navItem.title}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
}
